const defaultAvailabilityAddressSubmit = ({ setIsSubmitted }) => {
  setIsSubmitted(true)
}

export default defaultAvailabilityAddressSubmit
